import React from 'react';
import classnames from 'classnames';
import License from '../../../License';
import LegacyTextRenderer from '../../../TextRenderer/LegacyTextRenderer';
import Tags from '../../../Tags';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import DateAndMatureIndicator from '../../../SubmissionDetails/_partials/DateAndMatureIndicator';
import s from './Project.scss';
var ProjectDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, isMature = _b.isMature, deviationId = _b.deviationId, author = _b.author, publishedTime = _b.publishedTime, _c = _b.extended, _d = _c === void 0 ? {} : _c, license = _d.license, description = _d.description, tags = _d.tags, className = _a.className, contentClassName = _a.contentClassName;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return (React.createElement("div", { className: classnames(s['root'], className, contentClassName) }, isExtendedLoaded && (React.createElement(React.Fragment, null,
        tags && (React.createElement("div", { className: s['tags'] },
            React.createElement(Tags, { key: "detailsTags-" + deviationId, tags: tags }))),
        description && (React.createElement(LegacyTextRenderer, { html: description, className: s['description'], theme: "literature-description" })),
        React.createElement("div", { className: s['misc'] },
            React.createElement(DateAndMatureIndicator, { publishedTime: publishedTime, isMature: isMature }),
            React.createElement("div", { className: s['license'] },
                React.createElement(License, { license: license, author: author, publishedTime: publishedTime })))))));
};
ProjectDetails.displayName = 'ProjectDetails';
export default ProjectDetails;
//# sourceMappingURL=Project.js.map